import { createTypeAction } from '@gu-corp/redux-async-lib';

export const openDrawer = createTypeAction('OPEN_DRAWER', () => {
  // Just for temporary
});
export const closeDrawer = createTypeAction('CLOSE_DRAWER', () => {
  // Just for temporary
});
